/**
 * Vul `{naam}`-placeholders in een vertaalde tekst in (specs/20261016-taal-bewonersapp).
 * Een onbekende placeholder blijft staan, zodat een vergeten parameter zichtbaar is in
 * plaats van stil te verdwijnen.
 */
export function tf(template: string, params: Record<string, string | number> = {}): string {
  return template.replace(/\{(\w+)\}/g, (whole, key: string) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : whole,
  );
}
